import PropTypes from 'prop-types'
import {Flex, Text, Button} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import {HourglassIcon} from '../../icons'

const PROVIDER_NAMES = {
  quickbooks: 'QuickBooks',
  myob: 'MYOB',
  xero: 'Xero',
}

const ReviewModalStepContent = ({onClose, provider}) => {
  const {t} = useTranslation('invoiceEmailTemplates')

  const providerName = PROVIDER_NAMES[provider]

  return (
    <Flex justify="center" align="center" height="100%">
      <Flex direction="column" width="400px" gap={6}>
        <Flex gap={1} align="center">
          <HourglassIcon color="mld.warning.800" boxSize="26px" />
          <Text
            fontSize="sm"
            fontWeight="medium"
            textTransform="uppercase"
            textColor="mld.warning.800"
          >
            {t('modal.review.subtitle')}
          </Text>
        </Flex>
        <Flex direction="column" gap={6}>
          <Text
            color="black"
            fontWeight="regular"
            fontSize="2xl"
            lineHeight="90%"
          >
            {t('modal.review.title')}
          </Text>
          <Text
            color="black"
            fontWeight="regular"
            fontSize="regular"
            lineHeight="150%"
          >
            {t('modal.review.description', {
              provider: providerName,
            })}
          </Text>
          <Button
            className="fs-unmask"
            variant="secondary"
            width="20%"
            onClick={onClose}
            _hover={{}}
          >
            <Text textTransform="uppercase">{t('modal.buttons.close')}</Text>
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}

ReviewModalStepContent.propTypes = {
  onClose: PropTypes.func.isRequired,
  provider: PropTypes.string.isRequired,
}

export default ReviewModalStepContent
